import React from 'react';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';

export default function ContactInfoSection({ sectionTitle }) {
  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="35" lg="25" />

      <div className="contact-info-grid">
        <div className="contact-info-left">
          <IconBoxStyle11
            title="Phone"
            subTitle="(845) 320-2855"
            iconSrc="/images/contact/icon_1.svg"
          />

          <IconBoxStyle11
            title="Email"
            subTitle="info@starbrightaba.com"
            iconSrc="/images/contact/icon_2.svg"
          />
        </div>

        <IconBoxStyle11
          title="Locations"
          subTitle={
            <div className="location-list">
              <div>
                <strong>Harriman Center</strong><br />
                118 River Rd #14<br />
                Harriman, NY 10926
              </div>

              <div>
                <strong>Newburgh Center</strong><br />
                289 North Plank Road, #3<br />
                Newburgh, NY 12550
              </div>
            </div>
          }
          iconSrc="/images/contact/icon_3.svg"
        />
      </div>

      <Spacing md="35" />

      <div className="contact-map-grid">
        <div>
          <h3>Harriman Center</h3>
          <iframe
            title="Harriman Center Map"
            src="https://www.google.com/maps?q=118+River+Rd+%2314,+Harriman,+NY+10926&output=embed"
            allowFullScreen
          />
        </div>

        <div>
          <h3>Newburgh Center</h3>
          <iframe
            title="Newburgh Center Map"
            src="https://www.google.com/maps?q=289+North+Plank+Road,+%233,+Newburgh,+NY+12550&output=embed"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}